<template>
  <div class="po-r w100 bg-w pt20 pb20 pl20 pr20" v-loading="loading">
    <p class="w100 font-16">办公区服务配置</p>
    <div class="w100 pb20 pt20 cl-f">
      <div class="fr">
        <span class="ml20">分组：</span>
        <el-select style="width: 160px;" v-model="searchGroup" placeholder="请选择" @change="page = 1, fetchList()">
          <el-option label="全部" :value="''"></el-option>
          <el-option v-for="(val, key) in grounpList" :key="key" :label="val.name" :value="val.id"></el-option>
        </el-select>
        <span class="ml20">搜索关键字：</span>
        <el-input class="mr20" style="width: 160px;" v-model="searchText" @keyup.enter.native="page = 1, fetchList()" placeholder="可输入关键字查询"></el-input>
        <el-button type="primary" @click="page = 1, fetchList()">查询</el-button>
        <el-button type="warning" :loading="loading" @click="showAddView">新增</el-button>
        <el-button type="success" :loading="loading" @click="favorChange(true)">默认收藏</el-button>
        <el-button type="info" :loading="loading" @click="favorChange(false)">取消收藏</el-button>
        <el-button @click="delRole">删除</el-button>
      </div>
    </div>

    <el-table class="w100 tx-c my-table" :data="list" stripe border height="550" @selection-change="changeListSelect" :default-sort="{ prop: 'sort' }">
      <el-table-column align="center" type="selection" width="50"></el-table-column>
      <el-table-column align="center" label="排序" prop="sort" width="80" sortable></el-table-column>
      <el-table-column align="center" label="服务名称" prop="name" sortable></el-table-column>
      <el-table-column align="center" label="图标" width="100">
        <template slot-scope="scope">
          <img :src="scope.row.logoUrl" width="40px" height="40px">
        </template>
      </el-table-column>
      <el-table-column align="center" label="启用状态" width="90">
        <template slot-scope="scope">
          <span class="green" v-if="scope.row.status == 0">启用</span>
          <span class="grey" v-else-if="scope.row.status == 1">停用</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="服务对象">
        <template slot-scope="scope">
          <p v-for="(item, index) in scope.row.roleName" :key="index">{{ item }}</p>
        </template>
      </el-table-column>
      <el-table-column align="center" label="所属分组" prop="groupName"></el-table-column>
      <el-table-column align="center" label="创建时间">
        <template slot-scope="scope">
          <span>{{ scope.row.createTime | filterDate('yyyy-MM-dd') }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="操作" width="60">
        <template slot-scope="scope">
          <span class="ml10 mr10 blue cu-p font-14" @click="showEditView(scope.row)"><i class="el-icon-edit"></i></span>
        </template>
      </el-table-column>
    </el-table>

    <div class="w100 mt20 tx-r">
      <el-pagination @size-change="changeSize" @current-change="changePage" :current-page="page" :page-sizes="[5, 30, 50, 100]" :page-size="size" layout="total, sizes, prev, pager, next, jumper" background :total="total"></el-pagination>
    </div>

    <el-dialog :visible.sync="isShow" :close-on-click-modal="!updataing" :close-on-press-escape="!updataing" :show-close="!updataing">
      <span class="font-16" slot="title">{{ title ? title : '新增' }}</span>
      <div class="w100">
        <table class="w100 table-view" v-if="selData">
          <tbody>
            <tr>
              <td>服务名称</td>
              <td>
                <el-input v-model="selData.name" placeholder="请输入服务名称"></el-input>
              </td>
            </tr>
            <tr>
              <td>是否启用</td>
              <td>
                <el-switch v-model="selData.status" active-color="#13ce66"></el-switch>
              </td>
            </tr>
            <tr>
              <td>所属分组</td>
              <td>
                <el-select v-model="selData.groupId" placeholder="请选择">
                  <el-option v-for="(val, key) in grounpList" :key="key" :label="val.name" :value="val.id"></el-option>
                </el-select>
              </td>
            </tr>
            <tr>
              <td>服务对象</td>
              <td>
                <el-select v-model="selData.roleIds" placeholder="请选择" multiple collapse-tags>
                  <el-option v-for="(item, index) in roleList" :key="index" :label="item.name" :value="item.id"></el-option>
                </el-select>
              </td>
            </tr>
            <tr>
              <td>排序</td>
              <td>
                <el-input-number v-model="selData.sort" :max="999" :min="1"></el-input-number>
              </td>
            </tr>
            <tr>
              <td>服务链接</td>
              <td>
                <el-input v-model="selData.ssoUrl" placeholder="请输入服务链接"></el-input>
              </td>
            </tr>
            <tr>
              <td>图标链接</td>
              <td>
                <el-input v-model="selData.logoUrl" placeholder="请输入图标链接"></el-input>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <span slot="footer">
        <el-button @click="isShow = false" :loading="updataing">取 消</el-button>
        <el-button type="primary" :loading="updataing" :disabled="selData.name == '' || !selData.sort || selData.groupId == '' || selData.roleIds.length == 0 || selData.ssoUrl == '' || selData.logoUrl == ''" @click="cilckUpdata">提 交</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "OfficeRoleForHref",
  components: {},
  props: [],
  data() {
    return {
      loading: false,

      searchText: "",
      searchGroup: "",

      list: [],
      page: 1,
      size: 50,
      total: 0,

      listSelect: [],

      isShow: false,
      updataing: false,
      title: "",
      selData: {
        id: "",
        name: "",
        groupId: "",
        status: true,
        roleIds: [],
        sort: 1,
        ssoUrl: "",
        logoUrl: ""
      },

      grounpList: [],
      roleList: []
    };
  },
  computed: {
    ...mapState(["userData", "userToken"])
  },
  created() {
    this.fetchGrounpList();
  },
  mounted() {},
  methods: {
    fetchGrounpList() {
      this.loading = true;

      this.$http
        .post(`wiseduGroup/findAll`, {})
        .then(({ data }) => {
          // console.log(data.RetData);
          if (data.RetCode && data.RetStatus == 0) {
            this.grounpList = data.RetData;
            this.fetchRoleList();
          } else {
            this.fetchGrounpList();
          }
        })
        .catch(() => {
          this.fetchGrounpList();
        });
    },
    fetchRoleList() {
      this.loading = true;

      this.$http
        .get(`wserve/getWiseduRoles?token=${this.userToken}`, {})
        .then(({ data }) => {
          // console.log(data.RetData);
          if (data.RetCode && data.RetStatus == 0) {
            this.roleList = data.RetData;
            this.fetchList();
          } else {
            this.fetchGrounpList();
          }
        })
        .catch(() => {
          this.fetchGrounpList();
        });
    },
    fetchList() {
      this.loading = true;

      this.$http
        .post(
          `wserve/findPage`,
          this.$qs.stringify({
            pageNum: this.page,
            pageSize: this.size,
            name: this.searchText,
            groupId: this.searchGroup
          })
        )
        .then(({ data }) => {
          // console.log(data.RetData);
          if (data.RetCode && data.RetStatus == 0) {
            for (let item of data.RetData.list) {
              item.roleId = item.roles.map(val => val.id);
              item.roleName = item.roles.map(val => val.name);
            }
            this.list = data.RetData.list;
            this.total = data.RetData.total;
          } else {
            this.$message({
              message: data.RetMsg,
              type: "error"
            });
          }
          this.loading = false;
        })
        .catch(() => {
          this.$message({
            message: "网络请求错误，请检查网络",
            type: "error"
          });
          this.loading = false;
        });
    },
    showAddView() {
      this.title = "";
      this.selData = {
        name: "",
        groupId: "",
        status: true,
        roleIds: [],
        sort: 1,
        ssoUrl: "",
        logoUrl: ""
      };
      this.isShow = true;
    },
    showEditView(obj) {
      this.title = obj.name;
      this.selData = {
        id: obj.id,
        name: obj.name,
        groupId: obj.groupId,
        status: obj.status == 1 ? false : true,
        roleIds: obj.roleId,
        sort: obj.sort,
        ssoUrl: obj.ssoUrl,
        logoUrl: obj.logoUrl
      };
      this.isShow = true;
    },
    favorChange(isFavor) {
      if (!this.listSelect.length) {
        this.$message({
          message: `请至少选择一条数据提交`,
          type: "error"
        });
        return;
      }

      this.$confirm(
        isFavor
          ? "默认收藏操作将会在个人工作区直接展示该服务，确认收藏吗"
          : "取消收藏操作将会在个人工作区删除该服务，确认取消吗",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }
      )
        .then(() => {
          const obj = this.listSelect.map(val => val.id);
          const url = isFavor ? "wserve/applyFavor" : "wserve/cancelFavor";
          this.loading = true;

          this.$http
            .post(url, JSON.stringify(obj), {
              headers: {
                "Content-Type": "application/json;charset=utf-8"
              }
            })
            .then(({ data }) => {
              // console.log(data.resData);
              if (data.RetCode && data.RetStatus == 0) {
                this.$message({
                  message: data.RetData,
                  type: "success"
                });
                this.fetchList();
              } else {
                this.$message({
                  message: data.RetMsg,
                  type: "error"
                });
              }
              this.loading = false;
            })
            .catch(() => {
              this.$message({
                message: "网络请求错误，请检查网络",
                type: "error"
              });
              this.loading = false;
            });
        })
        .catch(() => {});
    },
    delRole() {
      if (!this.listSelect.length) {
        this.$message({
          message: `请至少选择一条数据提交`,
          type: "error"
        });
        return;
      }

      this.$confirm("是否删除选中", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          const obj = this.listSelect.map(val => val.id);
          this.loading = true;

          this.$http
            .post("wserve/delBatch", JSON.stringify(obj), {
              headers: {
                "Content-Type": "application/json;charset=utf-8"
              }
            })
            .then(({ data }) => {
              // console.log(data.resData);
              if (data.RetCode && data.RetStatus == 0) {
                this.$message({
                  message: data.RetData,
                  type: "success"
                });
                this.fetchList();
              } else {
                this.$message({
                  message: data.RetMsg,
                  type: "error"
                });
              }
              this.loading = false;
            })
            .catch(() => {
              this.$message({
                message: "网络请求错误，请检查网络",
                type: "error"
              });
              this.loading = false;
            });
        })
        .catch(() => {});
    },
    cilckUpdata() {
      let url = "";
      let obj = {};
      if (this.title == "") {
        url = "wserve/add";
        obj.name = this.selData.name;
        obj.groupId = this.selData.groupId;
        obj.status = this.selData.status ? 0 : 1;
        obj.roleIds = this.selData.roleIds.join(",");
        obj.sort = this.selData.sort;
        obj.ssoUrl = this.selData.ssoUrl;
        obj.logoUrl = this.selData.logoUrl;
      } else {
        url = "wserve/update";
        obj.id = this.selData.id;
        obj.name = this.selData.name;
        obj.groupId = this.selData.groupId;
        obj.status = this.selData.status ? 0 : 1;
        obj.roleIds = this.selData.roleIds.join(",");
        obj.sort = this.selData.sort;
        obj.ssoUrl = this.selData.ssoUrl;
        obj.logoUrl = this.selData.logoUrl;
      }
      console.log(obj);

      this.updataing = true;
      this.$http
        .post(url, this.$qs.stringify(obj))
        .then(({ data }) => {
          // console.log(data);
          if (data.RetCode && data.RetStatus == 0) {
            this.$message({
              message: data.RetData,
              type: "success"
            });
            this.fetchList();
          } else {
            this.$message({
              message: data.RetMsg,
              type: "error"
            });
          }
          this.updataing = false;
          this.isShow = false;
        })
        .catch(() => {
          this.$message({
            message: "网络请求错误，请检查网络",
            type: "error"
          });
          this.updataing = false;
          this.isShow = false;
        });
    },
    changeListSelect(value) {
      this.listSelect = value;
    },
    changeSize(value) {
      this.size = value;
      this.fetchList();
    },
    changePage(value) {
      this.page = value;
      this.fetchList();
    }
  },
  watch: {}
};
</script>

<style scoped>
.table-view {
  border-collapse: collapse;
}
.table-view td {
  padding: 10px;
  border: 1px solid #dddddd;
}
.table-view tr td:first-child {
  min-width: calc(5em + 20px);
  background: #efefef;
}
</style>
